import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  // Environment URLs - now loaded from environment configuration
  public ENVURL = environment.envUrl;
  public BASEURL = environment.baseUrl;
  public QBBaseURL = environment.qbBaseUrl;
  public QBIntuitUrl = environment.qbIntuitUrl;

  public Version = '1.0.0.0';

  public PRODUCTIMAGESURL = this.BASEURL + '/ProductImages/';
  public USERIMAGESURL = this.BASEURL + '/UserImages/';

  public UserLoginResponse: any;

  private productBaseUrls: { [key: string]: string } = environment.productBaseUrls;

  constructor(protected http: HttpClient) { }

  getIntuitConnectURL(productId: string): Observable<any> {
    const baseUrl = this.productBaseUrls[productId];
    if (!baseUrl) {
      return throwError('Invalid Product_Id');
    }
    return this.http.get(baseUrl + 'Intuit/GetClientConnectURL');
  }

  CheckPermissions(URL: any) {
    let menuListString = localStorage.getItem('menuData') as string;
    let menuList = JSON.parse(menuListString);
    if (
      menuList?.filter((item: any) => item.url == URL && item.isActive == true)
        .length == 0
    ) {
      return false;
      console.log('Redirected to dashboard');
    } else {
      return true;
    }
  }
}
